export const primaryColors = {
    25: "var(--primary-25)",
    50: "var(--primary-50)",
    100: "var(--primary-100)",
    200: "var(--primary-200)",
    300: "var(--primary-300)",
    400: "var(--primary-400)",
    500: "var(--primary-500)",
    600: "var(--primary-600)",
    700: "var(--primary-700)",
    800: "var(--primary-800)",
    900: "var(--primary-900)",
    950: "var(--primary-950)",
} as const;

export function getPrimaryColor(shade: string = "500"): string {
    return getComputedStyle(document.documentElement).getPropertyValue(`--primary-${shade}`).trim();
}

export const blueColors = {
    25: "#F9FBFF",
    50: "#F3F7FF",
    100: "#DEEBFF",
    200: "#B5D4FF",
    300: "#78B0FF",
    400: "#3A91FF",
    500: "#1272F0",
    600: "#0062E0",
    700: "#0055C5",
    800: "#0048AB",
    900: "#00337E",
    950: "#00235B",
} as const;

export const grayColors = {
    25: "#F9FBFD",
    50: "#F2F6FB",
    100: "#EBEFFA",
    200: "#DAE2F0",
    250: "#BEC7DE",
    300: "#B5BFD9",
    400: "#929EBB",
    500: "#667293",
    600: "#576383",
    700: "#465473",
    800: "#313E62",
    900: "#1E2A4A",
    950: "#080E24",
} as const;

export const greenColors = {
    25: "#F9FCF9",
    50: "#F2F9F3",
    100: "#DDF0DF",
    200: "#B7E0BC",
    300: "#7ACC89",
    400: "#35B763",
    500: "#00933B",
    600: "#008234",
    700: "#00712C",
    800: "#006125",
    900: "#004618",
    950: "#00310F",
} as const;

export const limeColors = {
    25: "#F8FDF4",
    50: "#F3FCEB",
    100: "#E9FBDB",
    200: "#D8F4BE",
    300: "#C1E69E",
    400: "#ACDA7D",
    500: "#87C445",
    600: "#73AE32",
    700: "#4F9400",
    800: "#417800",
    900: "#315500",
    950: "#1E3700",
} as const;

export const redColors = {
    25: "#FFFAF9",
    50: "#FEF4F3",
    100: "#FEE3DE",
    200: "#F8CBC4",
    300: "#F58D7E",
    400: "#ED5B4B",
    500: "#D92F23",
    600: "#C8170F",
    700: "#AF110A",
    800: "#980A06",
    900: "#6F0503",
    950: "#500302",
} as const;

export const orangeColors = {
    25: "#FFFCF9",
    50: "#FEF8F3",
    100: "#FEEDDE",
    200: "#F8DDC4",
    300: "#F5B87E",
    400: "#ED994B",
    500: "#E17815",
    600: "#D96900",
    700: "#BB5A00",
    800: "#9F4D00",
    900: "#6F3703",
    950: "#502802",
} as const;

export const skyColors = {
    25: "#F7FCFF",
    50: "#F0F9FF",
    100: "#E0F2FE",
    200: "#CBE5F5",
    300: "#B4D6EB",
    400: "#70B8DD",
    500: "#2B9ACF",
    600: "#107CB2",
    700: "#0369A1",
    800: "#075985",
    900: "#0C4A6E",
    950: "#06273A",
} as const;

export const purpleColors = {
    25: "#FFFAFF",
    50: "#F8EFFA",
    100: "#F6E3F9",
    200: "#EDCBF2",
    300: "#D89DE1",
    400: "#CA60DB",
    500: "#B11DC9",
    600: "#A800BE",
    700: "#9300A6",
    800: "#7F0090",
    900: "#5C006A",
    950: "#42004C",
} as const;

export const yellowColors = {
    25: "#FFFEF5",
    50: "#FEFCE8",
    100: "#FCF6D5",
    200: "#F9EDB5",
    300: "#F1DC89",
    400: "#E7C53D",
    500: "#E3A800",
    600: "#CA8A04",
    700: "#B16A03",
    800: "#8D4A00",
    900: "#713600",
    950: "#422006",
} as const;

export const KPI_COLORS = {
    red: redColors[500],
    yellow: yellowColors[500],
    green: greenColors[500],
} as const;

export const KPI_COLORS_ARRAY = [KPI_COLORS.red, KPI_COLORS.yellow, KPI_COLORS.green] as const;

export const KPI_BG_MAP: Record<string, string> = {
    [KPI_COLORS.red]: "bg-red-25 border-red-200",
    [KPI_COLORS.yellow]: "bg-yellow-25 border-yellow-300",
    [KPI_COLORS.green]: "bg-green-25 border-green-200",
} as const;

export const KPI_TEXT_MAP: Record<string, string> = {
    [KPI_COLORS.red]: "text-red-950",
    [KPI_COLORS.yellow]: "text-yellow-950",
    [KPI_COLORS.green]: "text-green-950",
} as const;
